import React, { useEffect, useState } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core'
import { dinamicTablesStyles } from "./styles"

const QuizzesTable = ({ info }) => {
  const [filteredArray, setFilteredArray] = useState(info)
  const [inputValue, setInputValue] = useState('')
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [count, setCount] = useState(info)
  const classes = dinamicTablesStyles()
   const filterQuizzes = (initialArray, key ) => {
    const newArray = initialArray.filter(el => el[key] > 0)
     setFilteredArray(newArray)
     setCount(newArray)
     setPage(0)
    if (key === 'todas') {
      setFilteredArray(info)
      setCount(info)
      setPage(0)
    }
  };
  const handleChange = (e) => {
    setInputValue(e.target.value);
    filterQuizzes(info, e.target.value)
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  useEffect(() => {
    setFilteredArray(info)
    setCount(info)
  }, [info])
  return (
    <Box className={classes.container}>
      <h3 className={classes.title}>Encuestas</h3>
      <FormControl >
        <InputLabel id='select-quizzes' style={{ color: '#5A5A5A' }}>Estado de la encuesta</InputLabel>
        <Select
          labelId='select-quizzes'
          value={inputValue}
          className={classes.select}
          onChange={e => handleChange(e)}
        >
          <MenuItem value='todas'>Todas las encuestas</MenuItem>
          <MenuItem value='enviadas'>Enviadas</MenuItem>
          <MenuItem value='consolidadas'>Consolidadas</MenuItem>
          <MenuItem value='pendientes'>Pendientes</MenuItem>
          <MenuItem value='sin_enviar'>Sin enviar</MenuItem>
        </Select>
      </FormControl>
      <TableContainer className={classes.tableContainer}>
        <Table>
          <TableHead className={classes.head}>
            <TableRow className={classes.rowHead}>
              <TableCell>Socio</TableCell>
              <TableCell>Encuestas enviadas</TableCell>
              <TableCell>Encuestas conciliadas</TableCell>
              <TableCell>Encuestas pendientes</TableCell>
              <TableCell>Encuestas sin enviar</TableCell>
            </TableRow>
          </TableHead>
          <TableBody className={classes.body}>
            {filteredArray?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => (
              <TableRow key={item.socio}>
                <TableCell style={{color: '#2699FB'}}>{item.socio}</TableCell>
                <TableCell className={classes.centeredCell}>{item.enviadas}</TableCell>
                <TableCell className={classes.centeredCell}>{item.consolidadas}</TableCell>
                <TableCell className={classes.centeredCell}>{item.pendientes}</TableCell>
                <TableCell className={classes.centeredCell}>{item.sin_enviar}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  )
}

export default QuizzesTable